import { globalToastStore } from '../../stores';
import { observer } from 'mobx-react';

// to be included ONLY in the layout component
const GlobalToast = () => globalToastStore.currentToast;

export default observer(GlobalToast);
